import { AnalyticsBrowser } from '@segment/analytics-next';

import { AnalyticConfigurationType, AnalyticEventProperties } from './types';

const createSegmentClient = () => {
  let _client: any;

  const initialize = (config: AnalyticConfigurationType) => {
    _client = AnalyticsBrowser.load({ writeKey: config.writeKey });
  };

  const track = (event: string, properties: AnalyticEventProperties) => {
    _client && _client.track({ event, properties });
  };

  const identify = (userId: string, traits = {}) => {
    _client && _client.identify(userId, traits);
  };

  const reset = () => {
    _client && _client.reset();
  };

  return { initialize, track, identify, reset };
};

const segmentClient = createSegmentClient();

export default segmentClient;
